import { Component } from "@angular/core";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Tool } from "src/app/models/Tool";
import { ToolUpdate } from "src/app/models/ToolUpdate";
import { ModalComponent, ModalService } from "src/app/services/modal.service";
import { ToolService } from "src/app/services/tool.service";

@Component({
  selector: "tool-notes-modal",
  templateUrl: "./tool-notes-modal.component.html",
  styleUrls: ["./tool-notes-modal.component.scss"],
  standalone: false,
})
export class ToolNotesModalComponent implements ModalComponent<ToolNotesModalComponent, Tool> {
  faSpinner = faSpinner;
  isLoading: boolean;

  constructor(
    private toolService: ToolService,
    public modalService: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: Tool,
    public dialogRef: MatDialogRef<ToolNotesModalComponent, void>,
  ) {}

  updateNotes(notes) {
    this.isLoading = true;
    this.toolService
      .updateNotes(this.data.companyId, this.data.serialNumber, {
        ...new ToolUpdate(),
        notes: notes,
      })
      .subscribe(
        () => {
          this.data.notes = notes;
          this.isLoading = false;
          this.modalService.close();
        },
        () => (this.isLoading = false),
      );
  }
}
